import React from 'react'
import Nav from '../Nav';

const Profile = () => {
  return (
    <div>
      <Nav/>
      <div className="container mx-auto p-4">
        <h1>My Account</h1>
        <p>Account details</p>
      </div>
    </div>
  )
}

export default Profile
